import React, { useRef } from "react";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

const ConfirmDialog = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  body,
  confirmLabel,
  cancelLabel,
  colorScheme = "red",
  isLoading = false
}) => {
  const cancelRef = useRef();
  const { t } = useTranslation();

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {title}
          </AlertDialogHeader>
          <AlertDialogBody>{body}</AlertDialogBody>
          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={onClose}>
              {cancelLabel || t("common.cancel", { defaultValue: "Cancel" })}
            </Button>
            <Button
              colorScheme={colorScheme}
              ml={3}
              isLoading={isLoading}
              onClick={async () => {
                await onConfirm();
                onClose();
              }}
            >
              {confirmLabel || t("common.confirm", { defaultValue: "Confirm" })}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};

export default ConfirmDialog;
